// src/components/ModellingArea.js
import React, { useCallback, useRef, useState } from 'react';
import { ToggleGroup, ToggleGroupItem } from 'components/ui/toggle-group';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import SelectModellingFeatures from './SelectModellingFeatures';
import SelectAvailabilityFeatures from './SelectAvailabilityFeatures';

export default function ModellingArea() {
  const [tab, setTab] = useState('player');
  const [pendingTab, setPendingTab] = useState(null);
  // Children report their unsaved-changes state up via onDirtyChange so we can
  // warn before a tab switch discards edits (the switch unmounts the child).
  const dirtyRef = useRef(false);

  const handleDirtyChange = useCallback((dirty) => {
    dirtyRef.current = dirty;
  }, []);

  const handleTabChange = (newTab) => {
    if (!newTab || newTab === tab) return;
    if (dirtyRef.current) {
      setPendingTab(newTab);
    } else {
      setTab(newTab);
    }
  };

  const confirmSwitch = () => {
    dirtyRef.current = false;
    setTab(pendingTab);
    setPendingTab(null);
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="mb-3 text-token-xl font-semibold">Modelling Features</h2>

        <ToggleGroup type="single" value={tab} onValueChange={handleTabChange}>
          <ToggleGroupItem value="player">Player Features</ToggleGroupItem>
          <ToggleGroupItem value="availability">Availability Features</ToggleGroupItem>
        </ToggleGroup>
      </div>

      {tab === 'player' ? (
        <SelectModellingFeatures onDirtyChange={handleDirtyChange} />
      ) : (
        <SelectAvailabilityFeatures onDirtyChange={handleDirtyChange} />
      )}

      <Dialog
        open={pendingTab !== null}
        onOpenChange={(open) => {
          if (!open) setPendingTab(null);
        }}
      >
        <DialogContent className="sm:max-w-[420px]">
          <DialogHeader>
            <DialogTitle>Discard unsaved changes?</DialogTitle>
            <DialogDescription>
              You have unsaved changes on this tab. Switching tabs will discard them.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setPendingTab(null)}>
              Cancel
            </Button>
            <Button variant="destructive" onClick={confirmSwitch}>
              Discard changes
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
